module.exports = __webpack_public_path__ + "img/color_drop4.8317d1da.svg";